import { useQuery } from '@tanstack/react-query'
import { billingApi } from '@/api/billing'

export function usePlanLimits() {
  const { data: subscription } = useQuery({
    queryKey: ['subscription'],
    queryFn: billingApi.getSubscription,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  const { data: plans = [] } = useQuery({
    queryKey: ['billing-plans'],
    queryFn: billingApi.listPlans,
    staleTime: 10 * 60 * 1000,
  })

  const { data: balance } = useQuery({
    queryKey: ['wallet-balance'],
    queryFn: billingApi.getWalletBalance,
    staleTime: 60 * 1000,
    retry: false,
  })

  const currentPlan = plans.find((p: any) => p.id === subscription?.plan_id)

  return {
    subscription,
    currentPlan,
    balance,
    isLoading: !subscription && !currentPlan,
    canChat: subscription?.chat_enabled ?? currentPlan?.chat_enabled ?? false,
    isCustomPricing: subscription?.is_custom_pricing ?? currentPlan?.is_custom_pricing ?? false,
    maxProjects: currentPlan?.max_projects ?? null,
    maxDocsPerProject: currentPlan?.max_documents_per_project ?? null,
    maxFieldsPerProject: currentPlan?.max_fields_per_project ?? null,
    balanceCredits: balance?.balance_credits ?? 0,
  }
}
